import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  INPUT_IMAGE_ROLE,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.FLUX_MULTI_IMAGE_EDIT_FLUX2_PRO,
  "provider": PROVIDER.FLUX,
  "action": IMAGE_ACTION.MULTI_IMAGE_EDIT,
  "mode": IMAGE_MODE.FLUX2_PRO,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      // The edit references are read by position, then up to MAX_IMAGE_STYLES style
      // references share the same total. With overlay_mask the backend caps the references
      // at two: image 1 is the base and image 2 the red overlay marking the regions to edit.
      "input_image": {
        "type": "array",
        "minItems": 2,
        "maxItems": 8,
        "items": {
          "type": "object",
          "properties": {
            "asset_id": { "type": "integer" },
            "role": { "type": "string", "enum": [INPUT_IMAGE_ROLE.REFERENCE, INPUT_IMAGE_ROLE.STYLE] },
          },
          "required": ["asset_id", "role"],
        },
      },
      "overlay_mask": {
        "type": "boolean",
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt", "input_image"],
  },
  "ui_schema": {},
}
